import { type SvgImageProps } from "@hopper-ui/components";
import { type ElementType } from "react";
import { createSvgImage } from "./createSvgImage.tsx";

export function createIllustration(src: ElementType, displayName: string) {
    const SvgImage = createSvgImage(src);

    // eslint-disable-next-line unicorn/consistent-function-scoping -- rule doesn't detect the closure over `SvgImage`, which is only referenced via JSX tag name
    const component = ({
        "aria-hidden": ariaHidden,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        ...props
    }: SvgImageProps) => {
        const computedAriaHidden = ariaHidden ?? (!ariaLabel && !ariaLabelledBy);

        return (
            <SvgImage
                aria-hidden={computedAriaHidden}
                aria-label={ariaLabel}
                aria-labelledby={ariaLabelledBy}
                {...props}
            />
        );
    };

    component.displayName = displayName;

    return component;
}
